import {
  effect,
  signal,
  type WritableSignal
} from '@angular/core';

export function linkedSignal<T>(source: () => T): WritableSignal<T> {
  const state = signal<T>(source());

  effect(() => {
    state.set(source());
  }, { allowSignalWrites: true });

  return state;
}
